import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (params) => `${API_URL}/api/v1/contact?id=${params}`;

const getContact = async (info) => {
  return await apiRequest(getUrl(info), "get");
};

export default getContact;